import { render, staticRenderFns } from "./DisbursementInputTypeSelect.vue?vue&type=template&id=a28e3238&"
import script from "./DisbursementInputTypeSelect.vue?vue&type=script&lang=js&"
export * from "./DisbursementInputTypeSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QSelect} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QSelect})
